import { createFileRoute } from "@tanstack/react-router";
import { SiteShell, PageHero } from "@/components/site/SiteShell";
import { Section, FAQ, CTABand } from "@/components/site/Blocks";
import { products } from "@/data/products";
import { buildHead } from "@/lib/seo-head";
import { PageEssentials, PageOutro } from "@/components/site/PageEssentials";
import heroFaq from "@/assets/hero/hero-faq.jpg.asset.json";

const HERO = {
  src: heroFaq.url,
  alt: "Welcoming single-family rental home at dusk beside a floating tablet displaying a frequently-asked-questions list with gold expand icons — investor loan FAQ for rental property owners",
};

const URL = "/faq";
const ALL_FAQS = products.flatMap((p) => p.faq).map((f) => ({ q: f.q, a: f.a }));
const KEYWORDS = [
  "DSCR loan FAQ",
  "investor loan questions",
  "DSCR loan requirements FAQ",
  "foreign national loan FAQ",
  "fix and flip loan FAQ",
  "construction loan FAQ",
  "Airbnb STR loan FAQ",
  "Section 8 rental loan FAQ",
  "business purpose loan questions",
  "DSCR down payment FAQ",
  "LLC mortgage FAQ",
].join(", ");

export const Route = createFileRoute("/faq")({
  head: () =>
    buildHead({
      title: "DSCR & Investor Loan FAQ | Simply Approved Mortgages",
      description:
        "Frequently asked questions across DSCR, Foreign National, Construction, Fix & Flip, Airbnb/STR, and Section 8 programs.",
      url: URL,
      keywords: KEYWORDS,
      breadcrumbs: [
        { name: "Home", url: "/" },
        { name: "FAQ", url: URL },
      ],
      service: { name: "Investor Loan Program FAQ" },
      faqs: ALL_FAQS,
      speakableSelectors: [".faq"],
      image: HERO.src,
      imageAlt: HERO.alt,
    }),
  component: FaqPage,
});

function FaqPage() {
  return (
    <SiteShell>
      <PageHero eyebrow="FAQ" title="Investor loan questions, answered." image={HERO} />
      <PageEssentials />
      <Section>
        {products.map((p) => (
          <div key={p.slug} className="mb-10">
            <h2 className="mb-4 font-display text-2xl font-bold text-brand">{p.name}</h2>
            <FAQ items={p.faq} />
          </div>
        ))}
      </Section>
      <CTABand title="Question we didn't answer?" body="Send it over — we reply within one business day." cta="Contact us" href="/contact" />
    <PageOutro />
      </SiteShell>
  );
}
